import apiService from '../../services/api';

// Init state
const state = {
    items: []
};

// Actions
const actions = {
    getList: (context, params) => {
        return apiService.get('data.index', params);
    },
    upload: (context, params) => {
        return apiService.postForm('data.upload', params);
    },
    create: (context, params) => {
        return apiService.post('data.index', params);
    },
    update: (context, params) => {
        return apiService.put('data.detail', params);
    },
    delete: (context, params) => {
        return apiService.delete('data.detail', params);
    },
    getDataType: (context, params) => {
        return apiService.get('data.dataType', params);
    }
};

// Mutation
const mutations = {};

export default {
    namespaced: true,
    state,
    actions,
    mutations
};
